const environments: { [char: string]: string } = {
  'web.wip.favur.xyz': 'WIP',
  'web.stg.favur.xyz': 'STG',
  'web.favur.ch': 'LIVE',
  'web.local.favur.ch': 'LOCAL',
  localhost: 'LOCAL',
}

export const APPLICATION_ENV = environments[window.location.hostname] || 'OTHER'
